<template>
  <n-page>
    <a-row>
      <a-col :lg="12" :md="24" :sm="24" :xs="24">
        <a-card title="Club Settings" class="">
          <a-form :form="form" layout="vertical">
            <template v-if="club.club_logo">
              <img
                :src="clubLogo"
                style="max-height: 120px; max-width: 100%"
                @error="defaultImage"
              />
            </template>
            <p class="gx-mt-3">
              We suggest using a 400x400px png or jpeg image for your logo
            </p>
            <a-form-item>
              <a-upload
                v-decorator="['upload']"
                accept="image/png,image/jpeg,/image/jpg"
                name="logo"
                :data="enjectRole"
                :action="`${action}/club/upload-club-logo`"
                :headers="{ Authorization: 'Bearer ' + userToken }"
                list-type="picture"
                @change="uploadImage"
              >
                <a-button> <a-icon type="upload" /> Change your Logo </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item label="Club Name">
              <a-input
                v-decorator="[
                  'club_name',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter the name of your club.',
                      },
                    ],
                  },
                ]"
                type="text"
              >
              </a-input>
            </a-form-item>
            <a-form-item label="Club Email">
              <a-input
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Club email is required.',
                      },
                    ],
                  },
                ]"
                type="text"
              >
              </a-input>
            </a-form-item>
            <a-form-item label="Contact Number">
              <a-input
                v-decorator="[
                  'contact_phone',
                  {
                    rules: [
                      {
                        pattern: /^[0-9]{6,10}$/,
                        message:
                          'Phone number must be between 6 and 10 digits and in numeric form.',
                      },
                    ],
                  },
                ]"
                type="text"
                inputmode="numeric"
                placeholder="Enter contact number"
              >
              </a-input>
            </a-form-item>
            <a-form-item label="Main Address">
              <a-input v-decorator="['address']" type="textarea"> </a-input>
            </a-form-item>
            <a-form-item label="Facebook URL">
              <a-input
                v-decorator="['facebook', facebookValidation]"
                type="text"
                placeholder="https://facebook.com"
              />
            </a-form-item>
            <a-form-item label="Twitter URL">
              <a-input
                v-decorator="['twitter', twitterValidation]"
                type="text"
                placeholder="https://x.com"
              >
              </a-input>
            </a-form-item>
            <a-form-item label="Website URL">
              <a-input
                v-decorator="['website', urlValidation]"
                type="text"
                placeholder="https://mywebsite.com"
              >
              </a-input>
            </a-form-item>
            <a-form-item class="gx-text-right">
              <a-button
                type="primary"
                html-type="submit"
                :loading="spinning"
                @click="handleForm"
              >
                Save Details
              </a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </n-page>
</template>

<script>
import { mapGetters } from "vuex";
import { AUTH_TOKEN, AUTH_USER } from "@/store/modules/auth/auth-actions";
import { GET_MY_CLUB } from "@/store/modules/club/club-actions";
import NPage from "@/components/ui/n-page/n-page";
import { clubService } from "@/common/api/api.service";
import NSectionLoading from "@/components/ui/n-section-loading/n-section-loading";
import notifications from "@/common/notifications/notification.service";
import MissingPng from "@/assets/missing-profile-photo.png";
export default {
  name: "MyClub",
  components: { NSectionLoading, NPage },
  data() {
    return {
      urlValidation: {
        rules: [
          {
            type: "url",
            pattern:
              /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
            message: "Please enter a valid URL",
          },
        ],
      },
      facebookValidation: {
        rules: [
          {
            pattern: /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(\.\?)?]/,
            message: "Please enter a valid Facebook URL",
          },
        ],
      },
      twitterValidation: {
        rules: [
          {
            pattern: /^(https?:\/\/)?(www\.)?x\.com\/[a-zA-Z0-9(\.\?)?]/,
            message: "Please enter a valid Twitter URL",
          },
        ],
      },
      form: this.$form.createForm(this),
      // action: 'http://192.168.1.11:8000/api',
      action: process.env.VUE_APP_API_HOST,
      spinning: false,
      phone: [
        {
          rules: [
            {
              pattern: /^[0-9]{6,10}$/,
              message: "Phone number must be between 6 and 10 digits",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      club: "getClub",
      user: [AUTH_USER],
      userToken: [AUTH_TOKEN],
      clubLoadingStatus: "getClubLoadingStatus",
    }),
    enjectRole() {
      let data = {
        role: this.user.select_role,
      };
      return data;
    },
    clubLogo: function () {
      if (this.club.club_logo) {
        return this.club.club_logo;
      } else {
        return MissingPng;
      }
    },
  },
  watch: {
    club: function (newData) {
      this.form.setFieldsValue({
        club_name: newData.club_name,
        email: newData.email,
        address: newData.address,
        contact_phone: newData.contact_number,
        facebook: newData.facebook,
        twitter: newData.twitter,
        website: newData.website,
      });
    },
  },
  mounted() {
    this.ClubInfo();
  },
  methods: {
    uploadImage() {
      this.ClubInfo();
    },
    handleForm() {
      this.form.validateFields((err, values) => {
        if (!err) {
          values.role = this.user.select_role;
          this.handleFormSubmit(values);
        }
      });
    },
    handleFormSubmit(values) {
      this.spinning = true;
      clubService
        .update(this.club.id, values)
        .then((resp) => {
          this.spinning = false;
          if (resp.data.success) {
            this.ClubInfo();
            notifications.success("Club updated successfully");
          } else {
            notifications.warn(resp.data.message);
          }
        })
        .catch(() => {
          notifications.warn("Something went wrong, please try again later");
          this.spinning = false;
        });
    },
    defaultImage(e) {
      e.target.src = MissingPng;
    },
    ClubInfo() {
      const data = {
        role: this.user.select_role,
      };
      this.$store.dispatch(GET_MY_CLUB, data);
    },
  },
};
</script>

<style scoped></style>
